import { ApiClient } from '@chametw/api-client';

export { ApiError } from '@chametw/api-client';
export type { ApiErrorBody, RequestOptions } from '@chametw/api-client';

export const apiClient = new ApiClient(import.meta.env.VITE_API_BASE_URL ?? '/api/v1');
